export default __webpack_public_path__ + "static/media/Alchemist's Pendant.e9b8ae29.jpg";